import { PageComponent } from "barba"

const parser = new DOMParser()

class CategoryGroup {

    constructor({ node }) {
        this.node = node
        this.container = this.node.querySelector('.category-group__container')
        this.links = this.container.querySelectorAll('.category-group__bike-link')
        this.template = this.container.querySelector('template')

        this.changeHandler = this.change.bind(this)

        this.links.forEach(x => {
            x.addEventListener('mouseenter', this.changeHandler)
            x.addEventListener('focusin', this.changeHandler)
        })
    }

    change(e) {
        const key = "%URL%"
        const url = e.target.dataset.imageUrl
        const picture = this.container.querySelector('.category-group__pic')

        if (picture && picture.dataset.imageUrl === url) {
            return
        }

        if (picture) {
            this.container.removeChild(picture)
        }

        if (!url) {
            return
        }
        
        let newPicture = document.importNode(this.template.content, true)

        newPicture.querySelectorAll('[data-image-url]').forEach(x => x.dataset.imageUrl = x.dataset.imageUrl.replace(key, url))
        newPicture.querySelectorAll('[srcset]').forEach(x => x.srcset = x.srcset.replace(key, url))
        newPicture.querySelectorAll('[src]').forEach(x => x.src = x.src.replace(key, url))

        this.container.append(newPicture)
        newPicture = null
    }

    destroy() {
        this.links.forEach(x => {
            x.removeEventListener('mouseenter', this.changeHandler)
            x.removeEventListener('focusin', this.changeHandler)
        })

        delete this.node
        delete this.container
        delete this.links
        delete this.template

        delete this.changeHandler
    }

}

new PageComponent(".category-group", CategoryGroup)